import React, { FunctionComponent, h } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars
import MobileDetect from "mobile-detect";
interface IRedirectUrl {
  iphoneUrl?: string;
  androidUrl?: string;
  defaultUrl?: string;
}

interface IAppProps {
  redirectUrls: IRedirectUrl;
}

const redirectOnHang = (defaultUrl: string) => {
  setTimeout(() => {
    window.location.href = defaultUrl;
  }, 300);
};

const detectAndRedirect = (redirectUrls: IRedirectUrl) => {
  const md = new MobileDetect(window.navigator.userAgent);
  const defaultUrlWithFallback = redirectUrls.defaultUrl || window.location.href; // In an unlikely case where it's not provided

  if (md.is("iPhone") && redirectUrls.iphoneUrl) {
    window.location.href = redirectUrls.iphoneUrl;
    redirectOnHang(defaultUrlWithFallback);
  } else if (md.phone() && redirectUrls.androidUrl) {
    window.location.href = redirectUrls.androidUrl;
    redirectOnHang(defaultUrlWithFallback);
  } else {
    window.location.href = defaultUrlWithFallback;
  }
};
const getScript = (redirectUrls) => {
  return { __html: JSON.stringify(detectAndRedirect(redirectUrls)) };
};

const App: FunctionComponent<IAppProps> = ({ redirectUrls }) => {
  return <div dangerouslySetInnerHTML={getScript(redirectUrls)} />;
};

export default App;
